import { useCallback, useEffect, useState, type SetStateAction } from 'react';
import { useTabId } from './workspaceContext';

function safe(value: unknown): string[] {
  return Array.isArray(value)
    ? [
        ...new Set(
          value.filter((id): id is string => typeof id === 'string' && id.length > 0 && id.length <= 200),
        ),
      ].slice(0, 200)
    : [];
}
function load(key: string, fallback: readonly string[]): string[] {
  try {
    const raw = sessionStorage.getItem(key);
    return raw === null ? safe(fallback) : safe(JSON.parse(raw));
  } catch {
    return safe(fallback);
  }
}
/** Раскрытие принадлежит вкладке и переносится вместе с ней в другое окно. Хранилище — адаптер владельца. */
export function useExpansionMemory(scope: string, fallback: readonly string[] = []) {
  const tab = useTabId() ?? 'gallery';
  const key = 'kaname.expansion.v1.' + scope + '.' + tab;
  const [state, setState] = useState(() => ({ key, value: load(key, fallback) }));
  let value = state.value;
  if (state.key !== key) {
    value = load(key, fallback);
    setState({ key, value });
  }
  useEffect(() => {
    if (state.key !== key) return;
    try {
      sessionStorage.setItem(key, JSON.stringify(state.value));
    } catch {
      /* Работа без памяти. */
    }
  }, [state, key]);
  const setValue = useCallback(
    (next: SetStateAction<string[]>) => {
      setState((current) => {
        const previous = current.key === key ? current.value : load(key, []);
        return { key, value: safe(typeof next === 'function' ? next(previous) : next) };
      });
    },
    [key],
  );
  return [value, setValue] as const;
}
